<template>
  <div class="LKRoadmapsFeedView">
    <LkBackLink
      :to="backRoute"
      class="LKRoadmapsFeedView__back"
    />

    <div v-if="school" class="LKRoadmapsFeedView__header-container">
      <h3 class="LKRoadmapsFeedView__header">
        Регион: <b>{{ school.region.name }}</b>
      </h3>
      <h3 class="LKRoadmapsFeedView__header">
        Муниципалитет: <b>{{ school.municipality.name }}</b>
      </h3>
      <h3 class="LKRoadmapsFeedView__header">
        ОО: <b>{{ school.name }}</b>
      </h3>
    </div>

    <LKRoadmapsFeedRoadmapView
      v-if="school"
      :school="school"
      :roadmap-id="id"
      v-on="$listeners"
    />

    <div
      v-else-if="errorMessage"
      class="LKRoadmapsFeedView__error-message"
      v-text="errorMessage"
    />
  </div>
</template>

<script>
/** @typedef {import('@/components/forms/BAteTree/utils').TreeNode} TreeNode */

import { getErrorMessages } from '@/helpers/getErrorMessages'
import { LKRoadmapsMapper } from './store'
import { LK_ROADMAPS_FEED_ROUTES } from './utils'

import LkBackLink from '@/components/lk/LkBackLink.vue'
import LKRoadmapsFeedRoadmapView from './components/LKRoadmapsFeedRoadmapView.vue'


export default {
  name: 'LKRoadmapsFeedView',
  inject: [
    'isAdresat',
    'isCurator',
  ],
  components: {
    LkBackLink,
    LKRoadmapsFeedRoadmapView,
  },
  inheritAttrs: false,
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    school_id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      errorMessage: null,
      isLoadingData: false,
      backRoute: { name: LK_ROADMAPS_FEED_ROUTES.LIST },
    }
  },
  computed: {
    ...LKRoadmapsMapper.mapState(['school']),
  },
  methods: {
    ...LKRoadmapsMapper.mapActions(['getSchool']),

    async asyncData() {
      this.isLoadingData = true
      const params = { school_id: this.school_id }

      try {
        await this.getSchool(params)
      } catch (e) {
        this.errorMessage = getErrorMessages(e).join(', ')
      }

      this.isLoadingData = false
    },
  },
}
</script>

<style lang="scss">
$light-blue: $webflow-color-blue-light;
$light-blue-hover: rgba($light-blue, 0.25);

$dark-blue: #49759d;
$color-light-grey: #eee;

.LKRoadmapsFeedView {
  &__header-container {
    padding: 25px;
    margin-bottom: 20px;
    background-color: $color-white;
  }

  &__back {
    margin-bottom: 10px;
  }

  &__error-message {
    font-size: 16px;
    color: $webflow-color-red;
  }

  & &__header {
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: normal;
    line-height: 1.25;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
